import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ACTIVE_ERROR_TYPE, ActiveErrorData } from '@store';
import { CommonStandaloneModule } from 'src/app/shared/common-standalone.module';

@Component({
  selector: 'app-power-limitation-statuses',
  standalone: true,
  imports: [CommonStandaloneModule],
  templateUrl: './power-limitation-statuses.component.html',
  styleUrl: './power-limitation-statuses.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PowerLimitationStatusesComponent {
  @Input() powerLimitationStatus: ActiveErrorData;
  ACTIVE_ERROR_TYPE = ACTIVE_ERROR_TYPE;
}
